import {
	Container,
	Grid,
	Card,
	Typography,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Button,
	Snackbar,
	CircularProgress,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import ButtonBase from "@material-ui/core/ButtonBase/ButtonBase";
import axios from "axios";
import React, { useContext, useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { TestContext } from "../../contexts/TestContext";
import { UserContext } from "../../contexts/UserContext";
import "./SectionD.css";
import useRecorder from "../../utils/useRecorder";
import MicIcon from "@material-ui/icons/Mic";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import StopIcon from "@material-ui/icons/Stop";
import SoundWave from "../../components/SoundWave/SoundWave";

const SectionD = (props) => {
	const history = useHistory();
	const location = useLocation();
	const questionArray = [...location.state.data.questions];
	const attemptedArray = [...location.state.data.attempted];
	const [currentQues, setQues] = useState(0);
	const { timer, open_time, remaining_time } = useContext(TestContext);
	const { autoLogOut } = useContext(UserContext);

	const [loading, setLoading] = useState(false);
	const [loadingSnack, setLoadingSnack] = useState(false);
	const [successSnackbar, setSuccessSnackbar] = useState(false);
	const [sizeSnackbar, setSizeSnackbar] = useState(false);
	const [infoModal, setInfoModal] = useState(true);
	// const [confirmModal, setConfirmModal] = useState(false);

	// Audio Related
	const [audioURL, isRecording, startRecording, stopRecording, resetRecorder] = useRecorder();
	const [recorded, setRecorded] = useState(false);
	const [uploading, setUploading] = useState(false);
	const [progress, setProgress] = useState(0);
	const [processing, setProcessing] = useState(false);

	const calculateProgress = (loaded, total) => {
		const percent = Number((loaded / total) * 100);
		setProgress(percent);
	};
	const [audio, setAudio] = useState();

	const handleSubmit = async (change) => {
		setLoading(true);
		const token = localStorage.getItem("token");

		if (!recorded || questionArray[currentQues].uploaded || !audio) {
			if (change === 0) {
				// setConfirmModal(true);
				backToSections();
			} else {
				setQues((prev) => prev + change);
				if (questionArray[currentQues + change].uploaded) setRecorded(true);
				else setRecorded(false);
				setLoading(false);
			}
			return;
		}

		try {
			const url = `${process.env.REACT_APP_BACKEND_URL}/sectionD/audio?question=${
				currentQues + 1
			}`;
			const form = new FormData();
			form.append("audio", audio, "audio.ogg");
			form.append("sectionDId", questionArray[currentQues]._id);
			setLoadingSnack(true);
			setUploading(true);
			const total = audio.size;
			// console.log(total);
			if (total < 100 * 1000 * 1000) {
				await axios
					.post(url, form, {
						headers: {
							Authorization: `Bearer ${token}`,
						},
						onUploadProgress: (progressEvent) =>
							calculateProgress(progressEvent.loaded, total),
					})
					.then((res) => {
						// console.log(res);
						setLoading(false);
						setLoadingSnack(false);
						setSuccessSnackbar(true);
						resetRecorder();
						setUploading(false);
						questionArray[currentQues].uploaded = audioURL;
						if (change === 0) {
							// setConfirmModal(true);
							backToSections();
						} else {
							setAudio(null);
							setQues((prev) => prev + change);
							if (questionArray[currentQues + change].uploaded) setRecorded(true);
							else setRecorded(false);
						}
					});
			} else {
				setLoading(false);
				setLoadingSnack(false);
				setSizeSnackbar(true);
				resetRecorder();
				setUploading(false);
				setAudio(null);
				setRecorded(false);
			}
		} catch (error) {
			// console.log(error);
			setLoadingSnack(false);
			setUploading(false);
			setLoading(false);
			if (error.response.status === 420) {
				autoLogOut();
			}
		}
	};

	const handleChange = (index) => {
		const change = index - currentQues;
		// console.log(index, change);
		if (change !== 0) handleSubmit(change);
	};

	const backToSections = () => {
		history.replace({
			pathname: `/test/sections`,
			state: {
				time: remaining_time,
				openTime: open_time,
			},
		});
	};

	useEffect(() => {
		// console.log(audioURL);
		const blob = fetch(audioURL).then((res) => {
			return res.blob();
		});
		blob.then((data) => {
			// console.log(data);
			setAudio(data);
			setProcessing(false);
		});
	}, [audioURL]);

	// Fill in Attempted Questions
	useEffect(() => {
		for (let i = 0; i < attemptedArray.length; i++) {
			let index = questionArray.findIndex((x) => x._id === attemptedArray[i].sectionDId);
			questionArray[index].uploaded = attemptedArray[i].link;
		}
		// eslint-disable-next-line
	}, []);

	return (
		<Container className="test-page">
			{questionArray.length > 0 ? (
				<Grid container>
					<Grid
						item
						container
						xs={12}
						style={{
							marginTop: 10,
							marginBottom: 15,
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<Grid item xs={6}>
							<Button
								variant="outlined"
								color="secondary"
								style={{ float: "left", padding: "3px 15px !important" }}
								onClick={() => {
									handleSubmit(0);
								}}
							>
								{"<< Go to Sections"}
							</Button>
						</Grid>
						<Grid item xs={6}>
							<span style={{ float: "right" }}>{timer}</span>
						</Grid>
					</Grid>
					<Grid
						container
						item
						xs={12}
						md={3}
						style={{ marginTop: 10, flexDirection: "column" }}
					>
						<Grid item container>
							{questionArray.map((question, index) => (
								<Grid item key={question._id}>
									<ButtonBase
										className={
											index === currentQues
												? "q-link selected"
												: question.uploaded
												? "q-link attempted"
												: "q-link"
										}
										onClick={() => {
											if (!isRecording) handleChange(index);
										}}
									>
										<Typography>{index + 1}</Typography>
									</ButtonBase>
								</Grid>
							))}
						</Grid>
						<Grid item container style={{ marginTop: 20 }}>
							<Grid item container xs={12}>
								<ButtonBase className="q-link demo selected" />
								<Typography variant="body2">Current Question</Typography>
							</Grid>
							<Grid item container xs={12}>
								<ButtonBase className="q-link demo attempted" />
								<Typography variant="body2">Attempted Question</Typography>
							</Grid>
							<Grid item container xs={12}>
								<ButtonBase className="q-link demo" />
								<Typography variant="body2">Unattempted Question</Typography>
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={12} md={9}>
						<Card className="question-panel">
							<Typography variant="body1" style={{ whiteSpace: "pre-wrap" }}>
								{questionArray[currentQues].directions}
							</Typography>
							<Typography
								variant="h6"
								style={{
									whiteSpace: "pre-wrap",
									fontWeight: "bolder",
									marginTop: "20px",
								}}
							>
								{questionArray[currentQues].text}
							</Typography>
							{questionArray[currentQues].audioUrl ? (
								<audio src={questionArray[currentQues].audioUrl} controls />
							) : (
								<></>
							)}
							<br />
							<div>
								{recorded ? (
									<div style={{ textAlign: "center" }}>
										<>
											{questionArray[currentQues].uploaded ? (
												<>
													<Typography variant="h6" color="primary">
														<CheckCircleIcon />
														<br />
														Recording Uploaded
													</Typography>
													<br />
													<br />
													<audio
														src={questionArray[currentQues].uploaded}
														controls
													/>
												</>
											) : processing ? (
												<CircularProgress
													variant="indeterminate"
													color="primary"
													size={30}
												/>
											) : !uploading ? (
												<>
													<Typography variant="h6" color="primary">
														Recording Saved
													</Typography>
													<br />
													<br />
													<audio src={audioURL} controls />
												</>
											) : (
												<CircularProgress
													color="secondary"
													variant="determinate"
													value={progress}
													size={30}
													style={{ marginBottom: "5%" }}
												/>
											)}
										</>
									</div>
								) : (
									<>
										{isRecording ? (
											<div style={{ textAlign: "center" }}>
												<SoundWave />
												<br />
												<div>
													<Button
														color="secondary"
														variant="outlined"
														onClick={() => {
															stopRecording();
															setProcessing(true);
															setRecorded(true);
														}}
														startIcon={<StopIcon />}
													>
														Stop Recording
													</Button>
												</div>
											</div>
										) : (
											<div style={{ textAlign: "center" }}>
												<Typography variant="h6">
													Click on button below to start recording!
												</Typography>
												<br />
												<Button
													color="secondary"
													variant="outlined"
													onClick={startRecording}
													startIcon={<MicIcon />}
												>
													Start Recording
												</Button>
											</div>
										)}
									</>
								)}
							</div>
							<br />
							{currentQues === 0 ? (
								<></>
							) : (
								<Button
									variant="outlined"
									color="secondary"
									style={{ float: "left", padding: "3px 15px !important" }}
									onClick={() => {
										if (!isRecording) handleSubmit(-1);
									}}
									disabled={loading || isRecording}
								>
									{"< Previous"}
								</Button>
							)}
							{currentQues < questionArray.length - 1 ? (
								<Button
									variant="outlined"
									color="secondary"
									style={{ float: "right", padding: "3px 15px !important" }}
									onClick={() => {
										if (!isRecording) handleSubmit(1);
									}}
									disabled={loading || isRecording}
								>
									{"Next >"}
								</Button>
							) : (
								<Button
									variant="outlined"
									color="secondary"
									style={{ float: "right", padding: "3px 15px !important" }}
									onClick={() => {
										if (!isRecording) handleSubmit(0);
									}}
									disabled={loading || isRecording}
								>
									{"Save and Go back to Sections >"}
								</Button>
							)}
						</Card>
					</Grid>
				</Grid>
			) : (
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignContent: "center",
						height: "90vh",
					}}
				>
					<Typography color="secondary" variant="h1">
						Nothing to Show here
					</Typography>
					<Button
						variant="outlined"
						color="secondary"
						style={{ padding: "3px 15px !important" }}
						onClick={() => {
							backToSections();
						}}
					>
						{"<< Go to Sections"}
					</Button>
				</div>
			)}
			<Snackbar
				open={successSnackbar}
				onClose={() => setSuccessSnackbar(false)}
				autoHideDuration={2000}
			>
				<Alert severity="success" variant="filled">
					Answer saved successfully
				</Alert>
			</Snackbar>
			<Snackbar
				open={sizeSnackbar}
				onClose={() => setSizeSnackbar(false)}
				autoHideDuration={2000}
			>
				<Alert severity="error" variant="filled">
					Audio Size limit exceeded
				</Alert>
			</Snackbar>
			<Snackbar
				open={loadingSnack}
				onClose={() => setLoadingSnack(false)}
				autoHideDuration={4000}
			>
				<Alert severity="info" variant="filled">
					Saving your answer...
				</Alert>
			</Snackbar>
			<Dialog open={infoModal} onClose={() => setInfoModal(false)}>
				<DialogTitle>Some info on Section D</DialogTitle>
				<DialogContent>
					<ol>
						<li>
							<strong>You can only attempt each question once.</strong>
						</li>
						<li>Make sure you allow the permission to access microphone.</li>
						<li>Please keep audio length upto 1 minute.</li>
					</ol>
				</DialogContent>
				<DialogActions>
					<Button
						variant="contained"
						color="primary"
						className="modal-back-btn"
						onClick={() => history.goBack()}
					>
						Go back
					</Button>
					<Button
						variant="contained"
						color="primary"
						className="modal-confirm-btn"
						onClick={() => setInfoModal(false)}
					>
						Confirm
					</Button>
				</DialogActions>
			</Dialog>
			{/* <Dialog open={confirmModal} onClose={() => setConfirmModal(false)}>
				<DialogTitle>Are you sure</DialogTitle>
				<DialogContent>
					<ol>
						<li>
							<strong>You can only attempt this section once.</strong>
						</li>
						<li>Make sure you have submitted all questions.</li>
					</ol>
				</DialogContent>
				<DialogActions>
					<Button
						variant="contained"
						color="primary"
						className="modal-back-btn"
						onClick={() => setConfirmModal(false)}
					>
						Go back
					</Button>
					<Button
						variant="contained"
						color="primary"
						className="modal-confirm-btn"
						onClick={() => backToSections()}
					>
						Confirm
					</Button>
				</DialogActions>
			</Dialog> */}
		</Container>
	);
};

export default SectionD;
